import {InterfaceApi} from "./InterfaceApi";


export class NullApi implements InterfaceApi {
    async request(
        message: {
            url: string,
            method: string,
            getParams: { [key: string]: string | string[] },
            postParams: { [key: string]: string | string[] },
            headers: { [key: string]: string },
            output: "json" | "text"
        }
    ): Promise<object> {
        return new Promise(async (resolve, reject) => {
            resolve({});
        });
    }
}